import { render, staticRenderFns } from "./log-login.vue?vue&type=template&id=481bbff0&"
import script from "./log-login.vue?vue&type=script&lang=js&"
export * from "./log-login.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports